<template>
  <a-layout-content class="overflow-hidden">
    <div class="filter-panel">
      <a-row>
        <a-col :span="24" class="other-filter">
          <div class="mr-20">关键字:</div>
          <a-input class="mr-20" placeholder="关键字" style="width: 220px" v-model="keyword" />
          <div class="mr-20">状态:</div>
          <a-select class="mr-20" style="width: 100px" v-model="status" placeholder="状态">
            <a-select-option v-for="o in statusList" :value="o.id" :key="o.val">{{ o.val }}</a-select-option>
          </a-select>
          <div class="mr-20">检测结果:</div>
          <a-select class="mr-20" style="width: 100px" v-model="checkResult" placeholder="检测结果">
            <a-select-option v-for="o in checkResultList" :value="o.id" :key="o.val">{{ o.val }}</a-select-option>
          </a-select>
          <div class="mr-20">整改结果:</div>
          <a-select class="mr-20" style="width: 100px" v-model="rectifyResult" placeholder="整改结果">
            <a-select-option v-for="o in rectify_results" :value="o.value" :key="o.value">{{ o.title }}</a-select-option>
          </a-select>
          <div class="mr-20">检测机构:</div>
          <a-select class="mr-20" style="width: 80px" v-model="deptId" placeholder="检测机构">
            <a-select-option v-for="o in depts" :value="o.deptId" :key="o.deptId">{{ o.deptName }}</a-select-option>
          </a-select>
          <a-button class="mr-20 view-btn large" html-type="submit" @click="getList(true)">搜索</a-button>
          <a-button class="mr-20 view-btn large" html-type="submit" @click="reset">重置</a-button>
        </a-col>
      </a-row>
    </div>
    <a-divider></a-divider>
    <div class="flex-container filter-panel filter-panel2">
      <sub-title>数据列表</sub-title>
      <ul class="handle-list" style="margin: -11px 0">
        <li class="handle-item" @click="exportData">
            <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" />&nbsp;
            <a href="javascript:;">导出</a>
        </li>
    </ul>
    </div>
    <a-divider></a-divider>
    <a-table :columns="columns" :dataSource="list" :rowKey="(record) => record.b_id" :loading="loading"
      :scroll="{ x: 1500, y: 800 }" v-if="list && list.length > 0" :pagination="pagination" @change="onPageChange"
      >
      <template slot="showTitle" slot-scope="text, record" ellipsis="...">
        <div :title="text" style="white-space: pre-wrap;">{{ text }}</div>
      </template>

      <template slot="showStatus" slot-scope="text, record">
        <div :title="text">{{ showStatus(record.b_status) }}</div>
      </template>

      <template slot="showRectifyResult" slot-scope="text, record">
        <div :title="text">{{ showRectifyResult(record.b_rectify_result) }}</div>
      </template>
      
      <template slot="showCheckResult" slot-scope="text, record">
        <div :title="text">{{ showCheckResult(record.b_check_result) }}</div>
      </template>

      <template slot="showFmtDate" slot-scope="text, record">
        <div :title="text">{{ showFmtDate(text) }}</div>
      </template>

      <template slot="showPicSlot" slot-scope="text, record" ellipsis="...">
        <span v-if="text && text.length > 2">
          <a-icon @click="showPic(text)" type="check-circle" theme="twoTone" two-tone-color="#52c41a"
            :style="{ fontSize: '20px' }" />
        </span>
        <span v-else>
          <a-icon type="close-circle" theme="twoTone" two-tone-color="red" :style="{ fontSize: '20px' }" />
        </span>
      </template>

    </a-table>
    <!-- 列表表格 -->

    <!-- 证件材料预览 -->
    <a-modal v-if="preview_visible" v-model="preview_visible" :zIndex="2" width="900px" :maskClosable="false"
      :footer="null">
      <div height="325px" width="450px">
        <img :src="url" width="100%" height="100%" />
      </div>
    </a-modal>

  </a-layout-content>
</template>
<script>
import SubTitle from "@/components/common/subTitle";
import { Divider, Modal } from "ant-design-vue";
import { get_check_list, exportData } from "@/api";
import { getUserInfo,beforeUpload,depts } from "@/plugins/common";
import moment from "moment";

export default {
  components: {
    SubTitle,
    ADivider: Divider,
    Modal,
  },
  data() {
    return {
      depts,
      deptId:"",
      // 显示列
      columns: [{
          title: "供应商名称",
          width: 150,
          dataIndex: "a_fullUnitName",
          key: "a_fullUnitName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "报装编号",
          width: 100,
          dataIndex: "a_bzNo",
          key: "a_bzNo",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "工程项目名称",
          width: 300,
          dataIndex: "a_projectName",
          key: "a_projectName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "物料名称",
          width: 150,
          dataIndex: "a_materialName",
          key: "a_materialName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "状态",
          width: 70,
          dataIndex: "b_status",
          key: "b_status",
          scopedSlots: { customRender: "showStatus" },
        },
        {
          title: "收样日期",
          width: 100,
          dataIndex: "b_received_at",
          key: "b_received_at",
          scopedSlots: { customRender: "showFmtDate" },
        },
        {
          title: "收样照片",
          width: 70,
          dataIndex: "b_received_url",
          key: "b_received_url",
          scopedSlots: { customRender: "showPicSlot" },
        },
        {
          title: "抽检时间",
          width: 100,
          dataIndex: "b_check_time",
          key: "b_check_time",
          scopedSlots: { customRender: "showFmtDate" },
        },
        {
          title: "报告编号",
          width: 90,
          dataIndex: "b_report_no",
          key: "b_report_no",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "检测结果",
          width: 90,
          dataIndex: "b_check_result",
          key: "b_check_result",
          scopedSlots: { customRender: "showCheckResult" },
        },
        {
          title: "整改内容",
          width: 90,
          dataIndex: "b_rectify_content",
          key: "b_rectify_content",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "整改结果",
          width: 90,
          dataIndex: "b_rectify_result",
          key: "b_rectify_result",
          scopedSlots: { customRender: "showRectifyResult" },
        },
        {
          title: "检测机构",
          width: 70,
          dataIndex: "deptName",
          key: "deptName",
          scopedSlots: { customRender: "showTitle" },
        }],
      // 部门集合
      list: [],
      pagination: {
        total: 0,
        current: 1,
        showTotal: (total) => {
          return `共 ${total} 条`;
        },
      },
      queryParams: {
        limit: 10,
        page: 0,
        searchCondition: {
          // check_result: 2
        },
      },
      loading: false,
      keyword: "",

      preview_visible:false,

      rectify_results: [{ title: "待整改", "value": 0 },{ title: "合格", "value": 1 }, { title: "不合格", "value": 2 }],

      statusList:[{id:0,val:"初始"},{id:1,val:"抽检"},{id:2,val:"覆盖"}],

      checkResultList:[{id:0,val:"初始"},{id:1,val:"合格"},{id:2,val:"不合格"}],

      status:undefined,
      checkResult:undefined,
      rectifyResult:undefined,
    };
  },
  mounted() {
    this.user = getUserInfo();
    this.getList();
  },
  methods: {
    moment,
    beforeUpload,
    getList(flag) {
      let self = this;
      if (this.loading) return;
      this.loading = true;
      if (flag == true) {
        this.pagination.current = 1;
      }
      this.queryParams.page = this.pagination.current - 1;

      if (this.keyword) {
        this.queryParams.searchCondition.keyword = this.keyword;
      } else {
        delete this.queryParams.searchCondition.keyword;
      }

      if (this.status != undefined) {
        this.queryParams.searchCondition.status = this.status;
      } else {
        delete this.queryParams.searchCondition.status;
      }

      if (this.checkResult != undefined) {
        this.queryParams.searchCondition.checkResult = this.checkResult;
      } else {
        delete this.queryParams.searchCondition.checkResult;
      }

      if (this.rectifyResult != undefined) {
        this.queryParams.searchCondition.rectifyResult = this.rectifyResult;
      } else {
        delete this.queryParams.searchCondition.rectifyResult;
      }
      if (this.deptId) {
        this.queryParams.searchCondition.deptId = this.deptId;
      } else {
        delete this.queryParams.searchCondition.deptId;
      }

      get_check_list(this.queryParams)
        .then((res) => {
          console.log(res);
          self.list = res.list;
          self.pagination.total = res.total;
        })
        .finally((res) => {
          self.loading = false;
        });
    },
    onPageChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.queryParams.page = pagination.current - 1;
      this.getList();
    },

    reset() {
      // clear conditions
      this.keyword = "";
      this.deptId = "";
      this.status = undefined;
      this.checkResult = undefined;
      this.rectifyResult = undefined;
      this.pagination.current = 1;
      this.queryParams.page = 0;
      this.getList();
    },

    rowClass(record) {
      return "checkFailedClass";
    },

    showStatus(status){
      let s = "";
      if( status == 1 ){
        s = "抽检";
      } else if( status == 2 ) {
        s = "覆盖";
      } else {
        s = "默认";
      }

      return s;
    },

    showRectifyResult(rectify_result) {
      let status = "";
      if( rectify_result == 1 ){
        status = "整改合格";
      } else if( rectify_result == 2 ) {
        status = "整改不合格";
      } else {
        status = "待整改";
      }

      return status;
    },

    showCheckResult(check_result){
      let status = "";
      if( check_result == 1 ){
        status = "合格";
      } else if( check_result == 2 ) {
        status = "不合格";
      } else {
        status = "默认";
      }

      return status;
    },

    showFmtDate(text){
      try{
        if( text ) {
          return text.substring(0,10);
        }
      }catch(e){
        console.log(e);
      }
      return text;
    },
    
    showPic(url) {
      console.log(url);
      this.url = JSON.parse(url)[0];
      if( this.url.endsWith(".pdf") ) {
        window.open(this.url);
      } else {
        this.preview_visible = true;
      }
    },

    exportData(){
      if (this.loading) return;
      this.loading = true;
      this.queryParams.page = this.pagination.current - 1;

      if (this.keyword) {
        this.queryParams.searchCondition.keyword = this.keyword;
      } else {
        delete this.queryParams.searchCondition.keyword;
      }

      if (this.status != undefined) {
        this.queryParams.searchCondition.status = this.status;
      } else {
        delete this.queryParams.searchCondition.status;
      }

      if (this.checkResult != undefined) {
        this.queryParams.searchCondition.checkResult = this.checkResult;
      } else {
        delete this.queryParams.searchCondition.checkResult;
      }

      if (this.rectifyResult != undefined) {
        this.queryParams.searchCondition.rectifyResult = this.rectifyResult;
      } else {
        delete this.queryParams.searchCondition.rectifyResult;
      }
      if (this.deptId) {
        this.queryParams.searchCondition.deptId = this.deptId;
      } else {
        delete this.queryParams.searchCondition.deptId;
      }
      this.queryParams.searchCondition.full = 2;
      exportData(this.queryParams)
          .then((res) => {
              console.log(res);
              window.open(res);
          })
          .finally((res) => {
              this.loading = false;
          });
    }

    //
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.other-filter {
  display: flex;
  height: 50px;
  align-items: center;

  .mr-20 {
    margin-right: 20px;
  }
}

.childCss {
  font-size: 14px;
}
</style>

<style>
.checkClass {
  color: orange;
}

.coverClass {
  color: blue;
}

.checkSuccessClass {
  color: green;
}

.checkFailedClass {
  color: red;
}
</style>
